/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
*/
import React, { useEffect, useState } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ProgressBar from 'react-bootstrap/ProgressBar'
import Button from 'react-bootstrap/Button'
import Classes from './index.module.css';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import 'react-multi-carousel/lib/styles.css';
import VideoCarousel from '../VideocarouselNew/index';
import axios from 'axios';
import UserWayAccessibilityMenu from "../UserWayAccessibilityMenu";
import ReviewCarousel from '../Latesttestimonials/testimonialcarousel'
const LicenseWrapper = styled.div`
              @font-face {
                  font-family: 'Handycheera';
                  src: url('../../../fonts/Handycheera\ Regular.otf') format('otf');
                  font-display: swap;
                } 
              .table-bordered{
                  border:none;
                  margin-bottom:0px
              }
              .page-link:focus{
                z-index: 3;
                outline: 0;
                box-shadow: none;
              }
            
              .total_reviews_block {
                  @media (min-width: 578px ){
                      padding-top: 65px;
                  }
              }
              .total_reviews_block {
                color:#00aae4;
                display: -webkit-inline-box;
                transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
                pointer-events: none;
                font-size: 1.2rem;
              }
              [class^="MuiBox-root"] {
                border-color: transparent;
                margin-bottom: 0px;
              }
              .page-link {
                color:#023f88 ;
              }
              `;

function WhySunwest({
  token,

}) {
 
  const [urlVideoData, setUrlVideoData] = useState([]);
  const navigate = useNavigate();
  const handleApplyNow = () => {
    navigate('/apply');
  };
 
  const [recommendation, setRecommendation] = useState(null);
  const [ratings, setratings] = useState(null);
  const [showOtherComponents, setShowOtherComponents] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 10) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  useEffect(() => {
    async function fetchData() {
      try {
        const response = await axios.get( process.env.REACT_APP_CDN_LINK + 'jsons/whysunwest.json');  
        const recommendationData = response.data.displayData.recommendation;
        const ratings = response.data.displayData.review.average;
        setRecommendation(recommendationData);
        setratings(ratings);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {

  }, [token])
  
 

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress === 0) {
          return 5;
        } else {
          return 0;
        }
      });
    }, 4000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
   
      <img
        src={"https://stagingresources.swmc.com/swmc-images/leftdots1.webp"}
        className={Classes.leftdots1}
        alt=""
        loading='lazy'
      />
      <img
        src={"https://stagingresources.swmc.com/swmc-images/leftdots1.webp"}
        className={Classes.leftdots2}
        alt=""
        loading='lazy'
      />
      <img
        src={"https://stagingresources.swmc.com/swmc-images/rightdots1.webp"}
        className={Classes.rightdots1}
        alt=""
        loading='lazy'
      />
      <img
        src={"https://stagingresources.swmc.com/swmc-images/rightdots2.webp"}
        className={Classes.rightdots2}
        alt=""
        loading='lazy'
      />
      <div className={Classes.bodydesign2blue} />
      <div className={Classes.bodydesign1blue} />
      <LicenseWrapper>
        <div className={Classes.hero_image}>

          <Container>
            <Row>
            <div className={Classes.userwaydivmobile}>
        <UserWayAccessibilityMenu color="white" width={40} height={40} />
        </div>
              <Col lg={8} xl={8} sm={12} >
                <div className={Classes.banner_text}>
                   <div>
                    <img
                      src={"https://stagingresources.swmc.com/swmc-images/Customer Reviewsdesk.webp"}
                      className={Classes.customerheading}
                    />
                  </div>  
      
                  <p className={Classes.banner_header2} id={Classes.bannerheadermb}>
                    We care deeply about our customers and their experience with us.See what people are saying about working with us!
                  </p>
                  <p className={Classes.banner_header2} id={Classes.bannerheaderdesk}>
                    We care deeply about our customers and their experience with us.<br />See what people are saying about working with us!
                  </p>
                  <div className={Classes.banner_content}>
                    <div className={Classes.sub_content_body}>
                      <div className={Classes.progresss_bar}>
                        <div className={Classes.progresss_bar_inner} style={{ width: `${recommendation}%` }} />
                      </div>
                      <h2 className={Classes.banner_sub_content} id={Classes.banner_sub_content1}>{recommendation}</h2>
                      <p className={Classes.banner_sub_text} id={Classes.bannersubtextdesk} style={{ paddingBottom: '2rem' }} >Would recommend Sun West Mortgage <br /> Company, Inc. to friends and family</p>
                      <p className={Classes.banner_sub_text} id={Classes.bannersubtextmb}>Would recommend Sun West Mortgage Company, Inc. to friends and family</p>
                    </div>
                    <div className={Classes.sub_content_body}>
      
                      <div className={Classes.stars_container}>
                        <div className={Classes.stars}></div>
                      </div>
                      <h2 className={Classes.banner_sub_content} id={Classes.avgcontent}>{ratings} <span style={{ color: 'white' }}>out of 5</span></h2>
                      <p className={Classes.banner_sub_text1}>Average customer review</p>
                    </div>
                  </div>
                </div>
              </Col>
              <Col>
              </Col>
            </Row>
          </Container>
        </div>

        <Container fluid={true} className={Classes.page_Container}>
          <Row>
            <Container className={Classes.pagination_Container}>
              <ReviewCarousel />
              <div
                id="scrollableDiv"
                style={{
                  overflow: 'auto',
                  display: 'block',
                  justifyContent: 'center'
                }}
              >
              </div>
            </Container>
          </Row>
          <Container>
            <div className={Classes.total_reviews_block}>
              {/* <h2 className={Classes.total_reviews_block_head}>34,689 Reviews</h2> */}
              <React.Fragment>
                <Row>
                  <Col sm={12} lg={4} style={{ zIndex: '1' }}>
                    <div style={{ alignItems: 'center' }}>
                      <ProgressBar
                        className={Classes.progress_bar}
                        id={Classes.progress_bar5}
                        now={87}
                        label="87%"
                        style={{ marginRight: '10px', flexGrow: 1 }}

                      />
                      <p>
                        <span className={Classes.starrating5}>★★★★★</span>
                      </p>
                    </div>
                  </Col>
                  <Col sm={12} lg={4} style={{ zIndex: '1' }}>

                    <div style={{ alignItems: 'center' }}>
                      <ProgressBar
                        className={Classes.progress_bar}
                        id={Classes.progress_bar4}
                        now={15}
                        label="11%"
                        style={{ marginRight: '10px', flexGrow: 1 }}
                      />
                      <p>
                        <span className={Classes.starrating4}>★★★★</span>
                      </p>
                    </div>
                  </Col>
                  <Col sm={12} lg={4} style={{ zIndex: '1' }}>
                    <div style={{ alignItems: 'center' }}>
                      <ProgressBar
                        className={Classes.progress_bar}
                        id={Classes.progress_bar3}
                        now={3.5}
                        label={<span className={Classes.labelcolor}>1%</span>}
                        color='#44B2FC'
                        style={{ marginRight: '10px', flexGrow: 1 }}
                      />
                      <p>
                        <span className={Classes.starrating3}>★★★</span>
                      </p>
                    </div>
                  </Col>
                </Row>
              </React.Fragment>
            </div>
          </Container>
          <Container className={Classes.getstartcont} style={{ padding: '0' }}>
            <Row style={{ padding: '0' }}>
              <Col style={{ padding: '0' }}>
                <div className={Classes.write_review_body}>
                  <h2 className={Classes.total_reviews_block_head}>Get Started Today</h2>
                  <p className={Classes.findtext} style={{ color: '#ffff' }}>
                    Find a licensed professional near you,
                    or start your application now!
                    <br />
                  </p>
                </div>
                <div className={Classes.applybtn}>
              <Button className={Classes.write_review_btn} style={{ marginBottom: '20px' }}>
              <a href="/why-sunwest/apply" className={Classes.btnatag} >
              Apply Now
                  </a>
              </Button>
              </div>
              </Col>
            </Row>
          </Container>
        </Container>
        {showOtherComponents && (
        <>
        <VideoCarousel 
        subheading="TESTIMONIALS"
        title="Borrower Videos"
      />
      </>
        )}
      </LicenseWrapper >

    </>
  )
}
export default WhySunwest




